import { Component } from '@angular/core';

@Component({
  selector: 'ui-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
})
export class CardHeaderComponent {}
